import { forwardRef, useCallback } from 'react';
import { useSnackbar, SnackbarContent, CustomContentProps } from 'notistack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

interface ReportCompleteProps extends CustomContentProps {
  id: any; // TODO: Should be in CustomContentProps
  message: string; // TODO: Should be in CustomContentProps
  className?: string;
  isPending?: boolean;
}

const SuccessToast = forwardRef<HTMLDivElement, ReportCompleteProps>(({ id, ...props }, ref) => {
  const { closeSnackbar } = useSnackbar();

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  return (
    <SnackbarContent ref={ref}>
      <Card
        className={clsx('w-400 ', props.isPending ? 'bg-white' : 'bg-[#EDF7ED]', props.className)}
      >
        <div className="flex items-center justify-between py-8 px-16">
          <div className="flex max-w-320">
            <FuseSvgIcon
              className={clsx(
                'mr-12',
                props.isPending ? 'text-blue-dark animate-spin' : 'text-[#2E7D32] ',
              )}
            >
              {props.isPending ? 'material-solid:autorenew' : 'material-solid:task_alt'}
            </FuseSvgIcon>

            <Typography
              variant="body2"
              className={clsx(
                'text-15 font-500  overflow-hidden',
                props.isPending ? 'text-blue-dark' : 'text-[#1E4620]',
              )}
            >
              {props.message}
            </Typography>
          </div>

          <div className="text-[#111827] self-start">
            <IconButton size="small" onClick={handleDismiss}>
              <FuseSvgIcon>material-solid:close</FuseSvgIcon>
            </IconButton>
          </div>
        </div>
      </Card>
    </SnackbarContent>
  );
});
SuccessToast.displayName = 'SuccessToast';

export default SuccessToast;
